import React, { Component, Fragment } from 'react'
// import Menu from '../components/Menu'
import TopBarLayout from '../layouts/TopBarLayout'

export default class DashboardLayout extends Component {
  render() {
    const { title, children, backText, backHref, noPad, contentRef } = this.props

    return (
      <Fragment>
        {/* <Menu icon="fas fa-bars">
          <Menu.Logo />
          <Menu.Divider />
          <Menu.Link to="/dashboard" icon="fas fa-th-large" str="titles.dashboard" />
          <Menu.Link to="/training" icon="fas fa-play-circle" str="Training" />
          <Menu.Link to="/settings" icon="fas fa-cog" str="titles.settings" />
          <Menu.Link href="mailto:glaucomaeyeguide@umich.edu" icon="fas fa-question" str="titles.emailSupport" />
          <Menu.Divider />
          <Menu.LanguageSwitcher />
          <Menu.QuitLink to="/logout" icon="fas fa-power-off" str="titles.signOut" />
        </Menu> */}
        <TopBarLayout title={title} backHref={backHref || "/dashboard"} backText={backText || "Dashboard"} noPad={!!noPad} contentRef={contentRef}>
          {children}
        </TopBarLayout>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/DashboardLayout.js